var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcReplayOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-replay-off_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-replay-off_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 7.875,
  fill: "#DADEE5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M17 8c-1.8 0-3.474.531-4.878 1.45l-1.26-1.27a.623.623 0 0 0-1.062.441v3.105c0 .432.351.774.774.774h3.105c.549 0 .828-.666.441-1.062l-.693-.693A7.16 7.16 0 0 1 17 9.791c3.987 0 7.2 3.213 7.2 7.2s-3.213 7.2-7.2 7.2a7.18 7.18 0 0 1-7.2-7.19.897.897 0 0 0-.891-.91.89.89 0 0 0-.909.882V17c0 4.96 4.041 9 9 9s9-4.04 9-9c0-4.959-4.041-9-9-9m-1.143 6.435a.66.66 0 0 0-.657.666v3.807c0 .513.567.837 1.008.567l3.177-1.908a.658.658 0 0 0 0-1.134l-3.177-1.908a.7.7 0 0 0-.342-.099z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-replay-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-replay-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8h18v18H8z"
})))));
export default SvgIcReplayOff;